module.exports = __webpack_public_path__ + "img/mnc.b4c9e8d8.png";